import Service from './Service';

export default class CountryService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/country/';
    }

}